/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-key */
import React, { useState } from 'react';
import { Button, Form, message, Spin } from 'antd-v5';
import { connect } from 'react-redux';
import { useQuery } from 'react-query';
import yn from 'yn';
import StandardLayoutV2 from '../../../../Layout/StandardLayoutV2';
import { OptionalKioskFields } from './components/OptionalKioskFields';
import { KioskSettingsFields } from './components/KioskSettingsFields';
import { getMessageSettings, saveMessageSettings } from '../../../../../core/apiRequests';
import { messageDispatcher } from '../../../../../components/Routes/Configuration/MessageSettings/largeMsgSettingFns';
import { parseKioskBody } from './helpers/parseKioskBody';

const KioskSettings = ({ flags, merchantId }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const ENABLE_CUSTOM_KIOSK_MODE = flags?.kiosk?.enabled && flags?.kiosk?.value === 'custom';

  const { isFetching, refetch } = useQuery(
    ['kioskSettings', merchantId],
    async () => {
      const response = await getMessageSettings('merchant', merchantId);
      if (response) {
        messageDispatcher(response);
      }
      const data = {
        background_color: response?.background_color,
        primary_color: response?.primary_color,
        secondary_color: response?.secondary_color,
        background_label_color: response?.background_label_color,
        background_url: response?.background_url,
        background_type: response.background_url && response.background_url.length > 0 ? 'image' : 'solid',
        bottom_section_header: response?.bottom_section_header,
        button_text: response?.button_text,
        appointments_button_text: response?.appointments_button_text,
        complete_subtitle: response?.complete_subtitle,
        complete_title: response?.complete_title,
        daily_contact_goal: response?.daily_contact_goal,
        double_opt_in: response?.double_opt_in,
        form_title: response?.form_title,
        intro_title: response?.intro_title,
        logo_url: response?.logo_url,
        opt_in_help: response?.opt_in_help,
        opt_in_legal: response?.opt_in_legal,
        opt_in_message: response?.opt_in_message,
        opt_in_title: response?.opt_in_title,
        round_logo: yn(response?.round_logo),
        show_address: yn(response?.show_address),
        show_anniversary: yn(response?.show_anniversary),
        show_birthday: yn(response?.show_birthday),
        show_email: yn(response?.show_email),
        email_required: yn(response?.email_required),
        top_section_header: response?.top_section_header,
        redirect_url: response?.redirect_url,
      };
      form.setFieldsValue(data);
    },
    {
      enabled: !!merchantId,
      refetchOnWindowFocus: false,
    },
  );

  const handleSave = async () => {
    setSaving(true);
    try {
      const values = await form.validateFields();
      const body = {
        ...values,
        background_color: values?.background_color
          ? typeof values?.background_color === 'string'
            ? values?.background_color
            : values?.background_color?.toHexString()
          : undefined,
        primary_color: values?.primary_color
          ? typeof values?.primary_color === 'string'
            ? values?.primary_color
            : values?.primary_color?.toHexString()
          : undefined,
        secondary_color: values?.secondary_color
          ? typeof values?.secondary_color === 'string'
            ? values?.secondary_color
            : values?.secondary_color?.toHexString()
          : undefined,
        background_label_color: values?.background_label_color
          ? typeof values?.background_label_color === 'string'
            ? values?.background_label_color
            : values?.background_label_color?.toHexString()
          : undefined,
      };
      await saveMessageSettings('merchant', merchantId, parseKioskBody(body), 'kioskConfig');
      refetch();
      message.success('Kiosk settings saved successfully');
    } catch (error) {
      console.error('Failed to save settings:', error);
      message.error('Failed to save Kiosk settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <StandardLayoutV2
      title="Kiosk Settings"
      classProps="flex-col-left"
      maxWidth="650px"
      styleProps={{ justifyContent: 'flex-start' }}
      containerStyles={{ backgroundColor: 'transparent', paddingRight: '32px', maxWidth: '560px' }}
      actions={
        <Button type="primary" onClick={handleSave} loading={saving} disabled={isFetching}>
          Save
        </Button>
      }
    >
      <Spin spinning={isFetching}>
        <Form form={form} layout="vertical" className="w-100-P" disabled={isFetching || saving}>
          {yn(ENABLE_CUSTOM_KIOSK_MODE) && <OptionalKioskFields form={form} />}
          <KioskSettingsFields form={form} />
        </Form>
      </Spin>
    </StandardLayoutV2>
  );
};

const mapStateToProps = state => ({
  merchantId: state.auth.merchantId,
  flags: state.auth.merchantFlags,
  settings: state.messageSettings,
});
export default connect(mapStateToProps, {})(KioskSettings);
